export default "__VITE_ASSET__CixNIPNQ__"